import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

export function useAdminFeedbacksQuery() {
  return useQuery({ queryKey: ["admin", "feedbacks"], queryFn: adminApi.listFeedbacks });
}
